import React from 'react';
import { WrenchIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-ink-950" data-id="element-137" data-mp="207t4gfx6vxoq">
      <div className="mx-auto w-full max-w-xl px-4 py-9 pb-28 text-center sm:pb-24 lg:max-w-3xl" data-id="element-138" data-mp="207b16zc40j7b">
        <div className="flex items-center justify-center gap-2" data-id="element-139" data-mp="2f42077hvfswe">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent" data-id="element-140" data-mp="2a6s458zz8izl">
            <WrenchIcon className="h-3.5 w-3.5 text-ink-950" aria-hidden="true" data-id="element-141" data-mp="1mfcyp7cwllk4" />
          </span>
          <span className="font-display text-sm uppercase tracking-wide text-white" data-id="element-142" data-mp="1hhulv5vrmm6u">
            Sistema Tecnico PRO 360™
          </span>
        </div>
        <p className="mt-4 text-[11px] leading-relaxed text-white/35 sm:text-xs" data-id="element-143" data-mp="1w827fuh2klbr">
          © 2026 Sistema Tecnico PRO 360™. Tutti i diritti riservati.
        </p>
        <p className="mt-2 text-[11px] leading-relaxed text-white/30 sm:text-xs" data-id="element-144" data-mp="13odeskk9n1xp">
          Questo sito non fa parte di Facebook o Meta Platforms Inc. I risultati possono variare in
          base all’impegno e al contesto di ogni tecnico.
        </p>
      </div>
    </footer>;
}